import { render, staticRenderFns } from "./DeveloperEditModelItems.vue?vue&type=template&id=6d67b914&"
import script from "./DeveloperEditModelItems.vue?vue&type=script&lang=js&"
export * from "./DeveloperEditModelItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports